import { BadgeAppearance as FluentBadgeAppearance, BadgeColor as FluentBadgeColor, BadgeShape as FluentBadgeShape, BadgeSize as FluentBadgeSize } from "@fluentui/web-components";
/** Appearance values for {@link Badge}. */
export const BadgeAppearances = { ...FluentBadgeAppearance };
export const BadgeAppearance = BadgeAppearances;
/** Color values for {@link Badge}. */
export const BadgeColors = { ...FluentBadgeColor };
export const BadgeColor = BadgeColors;
/** Shape values for {@link Badge}. */
export const BadgeShapes = { ...FluentBadgeShape };
export const BadgeShape = BadgeShapes;
/** Size values for {@link Badge}. */
export const BadgeSizes = { ...FluentBadgeSize };
export const BadgeSize = BadgeSizes;
//# sourceMappingURL=badge.options.js.map